var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"cardapio-digital-cabecalho-container custom-header"},[_c('img',{attrs:{"src":_vm.caminho,"alt":"Logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }